<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <WorkDocsSchemeClassTableItem v-for="item in items" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkDocsSchemeClassTableItem from 'components/setting/workDocsSchemeClass/WorkDocsSchemeClassTableItem'
export default {
  name: 'WorkDocsSchemeClassTable',
  props: ['items'],
  components: { WorkDocsSchemeClassTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-scheme_class']['tables']['nazvanie'],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {text: '', active: true},
      ]
    },
  },
}
</script>
